import React, { Component } from 'react';
import SceButton from "../../../../Common/CommonComponents/sceButton";
import ServiceAccountDetailsComponent from './serviceAccountDetailsComponent';
import overlayClasses from "./sceOverlayStyle.scss";
import classes from "./ViewEditPaperlessBilling.scss";
import { getLocalizedStrings } from "./paperlessBillingPopupLocalisedstrings";
import SceEmailDropDown from "../Common/sceEmailDropDown";
import FocusTrap from "focus-trap-react";
import SceErrorBox from '../../../../Common/ErrorBox/sceErrorBox';
import TwoFactorAuthContainer from "../../../common/TwoFactorAuthentication/TwoFactorAuthContainer";
import ViewEditHelper from '../Common/viewEditPaperlessBillingHelper';
import PaperlessBillingTurnoffPopup from './PaperlessBillingTurnoffPopup';
import PaperlessBillingDeEnrollConfirmPopup from './PaperlessBillingDeEnrollConfirmPopup';
class ViewEditPaperlessBilling extends React.Component {

  constructor(props) {
    super(props);
    this.strings = getLocalizedStrings("PbViewEditPopup");
    this.state = {
      showPbTurnOffPopUp:false, deEnrollConfirmPopup: false, yesCancelDeEnroll: false, ebillpaprCount:'', isPbDeEnrollConfirm: true, allEmails:[], soldEmails: this.props.preferenceData.emailSet || [], authEmails: this.props.preferenceDataAuth.emailSet || [], removeEmailsList: [], addEmailsList:[], popUpMsg:'', msgIcon:null, isViewEditPopup: true, editIndex: null, removeIndex: null, showButtonPress: false, showDropDown: true, showMoreOption: false, addEmail: false, removeIcon: false, removeButtonPress: false,  editButtonPress: false, doneButtonPress: false, cancelButtonPress: true, addButtonPress: false, selectedEmail: this.props.enrolledEmail, firstObj: {}, show: "", enrolledEmail: "", emailList: [], reviewObj: "", displayAdd: false, displayEdit: false,
      textEmail: "", showEmailExistsError: false, isEmailValid: false, doneEnable: false, newEmail: { value: '', isError: false, isValidated: false, forceValidate: false, resetTextBox: false }, newReEmail: { value: '', isError: false, isValidated: false, forceValidate: false, resetTextBox: false }, twoFactorAuthValues: { 'value': '', 'type': '', 'encValue': '', 'isPopUpOpen': false, 'addressGuid': this.props.customerData.addressGuid, 'mainBpNumber': this.props.bpNumber },
      previousMail: "", lastEnorlledEmail: "", allEmailCount: ""
    };
    this.setWrapperRef = this.setWrapperRef.bind(this), this.handleClickOutside = this.handleClickOutside.bind(this);
    this.removeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Action_Remove.svg';
    this.emailIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOn.svg';
    this.closeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
    this.addIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Action_Add.svg';
    this.verifiedIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Verified_Symbol.svg';
  }
  componentDidMount() { 
    this.updateAllEmails();
    let pbemails = JSON.parse(app.appService.getLocalStorage('pbemails'));
    this.setState({emailList : pbemails });
    document.addEventListener('mousedown', this.handleClickOutside); }
  componentWillUnmount() {
    this.props.preferenceData !== "" ? this.setState({ prefernceEmails: this.props.preferenceData }) : null;
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  updateAllEmails =() =>{
    const allEmails = [...this.state.soldEmails, ...this.state.authEmails];
    this.setState({allEmails : allEmails });
  }
  setWrapperRef(node) { this.wrapperRef = node; }
  handleClickOutside(event) { this.wrapperRef && !this.wrapperRef.contains(event.target) && this.props.isOpen(); }
  removeIconHandler =(index) =>{
    const updatedState = { ...this.state };
    updatedState.removeIndex = index, updatedState.editIndex = null;
    this.setState(updatedState);
  }
  removeButtonHandler = (email, index) => {
    const updatedState = { ...this.state };
    let removedMail = this.state.allEmails[index];
    updatedState.removeIndex = null, updatedState.doneEnable = true, updatedState.removeEmailsList.push(removedMail);
    if(index < this.state.soldEmails.length){
      updatedState.soldEmails = this.state.soldEmails.filter((emailObj) => emailObj.email !== email);
    }else{
      updatedState.authEmails = this.state.authEmails.filter((emailObj) => emailObj.email !== email);
    }
    this.setState(updatedState, ()=>{
      this.updateAllEmails();});
  }

  editButtonHandler = (email, index) => {
    const updatedState = { ...this.state };
    updatedState.editIndex = index, updatedState.removeIndex = null, updatedState.showEmailExistsError =false, updatedState.showDropDown = true, updatedState.textEmail = email, updatedState.lastEnorlledEmail= email, updatedState.doneEnable = false;
    this.setState(updatedState);
  }
  cancelButtonHandler = () => {
    const updatedState = { ...this.state };
    updatedState.editIndex = null, updatedState.showEmailExistsError =false, updatedState.removeIndex = null, updatedState.showDropDown = true, updatedState.textEmail = '', updatedState.lastEnorlledEmail='', updatedState.doneEnable = true;
    this.setState(updatedState);
  }
  semiCancelButtonHandler =() =>{
    const updatedState = { ...this.state };
    updatedState.removeIndex = null,updatedState.doneEnable = false, updatedState.editIndex = null;
    this.setState(updatedState);
  }
  valueCallBack = (email, show, isEmailValid) => {
    let updatedState = { ...this.state };
    if (show === "editShow") {
      const isNewEmail = this.state.soldEmails.some((obj)=> obj.email === email);
      if(isNewEmail){
        updatedState.textEmail = email, updatedState.showEmailExistsError =true;
      } else{
        const {soldEmailList, removeEmailsList} = ViewEditHelper.onUpdateEmail(email, this.props.accountData.contractAccountNumber, this.state.soldEmails, this.state.lastEnorlledEmail);
        updatedState.soldEmails = soldEmailList, updatedState.removeEmailsList=[...this.state.removeEmailsList, ...removeEmailsList], updatedState.showDropDown = true, updatedState.editIndex = null, updatedState.textEmail = email,updatedState.lastEnorlledEmail = '', updatedState.showEmailExistsError =false, updatedState.doneEnable = true;
      }
    } else {
      updatedState.textEmail = email, updatedState.show = show, updatedState.isEmailValid = isEmailValid, updatedState.showEmailExistsError =false;
    }
    this.setState(updatedState, () => { 
      this.updateAllEmails();});
  }
  ifEmailExists(emailId) {
    for (let i = 0; i < this.state.emailList.length; i++) {
      if (emailId.toLowerCase() === this.state.emailList[i].toLowerCase()) return true;
    }
    return false;
  }
  addButtonHandler = () => {
    let updatedState = { ...this.state };
    if (!this.ifEmailExists(this.state.textEmail) && this.state.textEmail !=='') {
      updatedState.twoFactorAuthValues.isPopUpOpen = true, updatedState.showEmailExistsError =false, updatedState.twoFactorAuthValues.type = 'email', updatedState.twoFactorAuthValues.value = this.state.textEmail;
      updatedState.twoFactorAuthValues.encValue = this.state.textEmail;
    } else if(this.state.textEmail ===''){
      updatedState.showEmailExistsError =false, updatedState.doneEnable = false;
    } else {
      updatedState.showEmailExistsError =true, updatedState.doneEnable = false;
    }
    this.setState(updatedState);
  }
  doneButtonHandler =() =>{
    const oldEmails = this.props.preferenceData.emailSet.map(obj => obj.email);
    const newEmails = this.state.soldEmails.map(obj => obj.email);
    const addEmailsList = this.state.soldEmails.filter( obj => !oldEmails.includes(obj.email));
    const entrolledEmails = [...this.props.preferenceData.emailSet, ...this.props.preferenceDataAuth.emailSet].map(obj => obj.email);
    const removeEmailsList = this.state.removeEmailsList.filter( obj => entrolledEmails.includes(obj.email) && !newEmails.includes(obj.email));
    const soldEmailsRemoved = this.state.removeEmailsList.every( obj => oldEmails.includes(obj.email));
    let allEmailCount = this.state.soldEmails.length + this.state.authEmails.length;
    // if(addEmailsList.length ===0 && soldEmailsRemoved){
      if(allEmailCount ===0){
      this.setState({showPbTurnOffPopUp: true});
    } else if(removeEmailsList.length > 0 || addEmailsList.length > 0){
      window.aUtils.sendAAEvent("button", "paperlessBillingDone");
      ViewEditHelper.onSaveChangesClick(this,removeEmailsList, addEmailsList, this.props.accountData.bpNumber);
    } else {
      window.aUtils.sendAAEvent("button", "paperlessBillingDone");
      this.setState({doneEnable:false});
    }
  }
  twofactorAuthPopupClose = (isTwoFaCompleted) => {
    let updatedState = { ...this.state };
    isTwoFaCompleted === true ? window.aUtils.sendAAEvent("button", "ok") : null;
    if (isTwoFaCompleted) {
        const {soldEmailList, removeEmailsList} = ViewEditHelper.onUpdateEmail(this.state.textEmail, this.props.accountData.contractAccountNumber, this.state.soldEmails, this.state.lastEnorlledEmail);
        updatedState.soldEmails = soldEmailList, updatedState.removeEmailsList=[...this.state.removeEmailsList, ...removeEmailsList], updatedState.editIndex = null, updatedState.lastEnorlledEmail = '', updatedState.doneEnable = true;
    } else {
      updatedState.textEmail = this.state.lastEnorlledEmail, updatedState.doneEnable = false;
    }
    updatedState.twoFactorAuthValues.isPopUpOpen = false, updatedState.showEmailExistsError =false, updatedState.twoFactorAuthValues.value = '', updatedState.twoFactorAuthValues.encValue = '', updatedState.lastEnorlledEmail = '',
    updatedState.twoFactorAuthValues.type = '', updatedState.showDropDown = true, updatedState.editIndex = null;
    this.setState(updatedState,()=>{
      this.updateAllEmails();});
  }
  onTwoFACompleted = (onTwoFACompleted) => {
    let updatedState = { ...this.state };
    if (onTwoFACompleted) {
      updatedState.emailList.push(updatedState.textEmail);
    }
  }
  viewAllHandler =() => {
    this.setState({ showMoreOption: !this.state.showMoreOption, showButtonPress: !this.state.showButtonPress  });
  }
  onAddEmailClickHandler =() =>{
    this.setState({textEmail:"", lastEnorlledEmail:'', showDropDown: false, editIndex: null, removeIndex: null, doneEnable:false, showEmailExistsError:false });
  }
  renderAddEmailJsx(){
    const enrolledEmail = this.state.textEmail;
    return (<div>
      <div className={classes.box}>
        <span className={classes.sceTextBox}><SceEmailDropDown placeholder={"Enter Email"} emailIds={this.props.emails} valueCallBack={this.valueCallBack} autoComplete="ScePbViewEditAdd" {...(enrolledEmail && {enrolledEmail})} handleClickOutSideTextBox={this.cancelButtonHandler} /></span>
        <SceErrorBox errorMessage={this.strings.emailExistsError} isError={this.state.showEmailExistsError} />
        <span className={classes.addCancelButtonAlign}>
          <div>
              <span className={classes.addButtonAlign}><button id="PbViewEditAdd" className={this.state.isEmailValid || this.state.showEmailExistsError ? classes.disabledAddButton : classes.AddButton} onClick={this.addButtonHandler} disabled={this.state.isEmailValid || this.state.showEmailExistsError}>{this.state.showDropDown? this.strings.SaveButtonValue :this.strings.AddButtonValue}</button></span>
              <span className={classes.editButtonAlign}><button className={classes.CancelButton} onClick={this.cancelButtonHandler}>{this.strings.CancelButtonValue}</button></span>
          </div>
        </span></div><div className={classes.dividerLine} /></div>);
  }
  cancelViewButtonHandlers() {
    let updatedState = { ...this.state };
    updatedState.deEnrollConfirmPopup = true, updatedState.yesCancelDeEnroll= false;
    this.setState(updatedState);
}
  getPBDeEnrollPopUp=()=>{
    return <PaperlessBillingTurnoffPopup accountData={this.props.accountData} submitDeenrollClick={ViewEditHelper.submitDeenrollClick.bind(this)} isOpen={this.cancelViewButtonHandlers.bind(this)} isPbDeEnrollConfirm={this.state.isPbDeEnrollConfirm} ebillpaprCount={this.state.authEmails.length} />;
}
getdeEnrollConfirmPopup = () => {
  return <PaperlessBillingDeEnrollConfirmPopup preferenceDataCount={this.props.preferenceData.emailSet.length} ebillpaprCount={this.state.authEmails.length} accountData={this.props.accountData} closePopup={this.props.closePopUp} yesCancelDeEnroll={this.state.yesCancelDeEnroll} soldEmails={this.state.soldEmails} />;
}
  render() {
    const turnOffPopUp = this.state.deEnrollConfirmPopup ? this.getdeEnrollConfirmPopup() : this.getPBDeEnrollPopUp();
    this.state.showMoreOption = this.state.allEmails.length >5;
    const showEmails = this.state.showMoreOption ? this.state.showButtonPress? this.state.allEmails: this.state.allEmails.slice(0,5) : this.state.allEmails;
    let serviceAccountDetailsJSX = <ServiceAccountDetailsComponent accountData={this.props.accountData} />;
    const canShowAddEmail = this.state.soldEmails.length < 3;
    return (
      <React.Fragment>
      {this.state.showPbTurnOffPopUp ? turnOffPopUp :
      <FocusTrap focusTrapOptions={{ allowOutsideClick: true }} >
        <div>
          <div tabIndex="0" className={[overlayClasses.sceOverlay, classes.sceSetNotificationsDialog].join(' ')}>
            <div className={this.state.isViewEditPopup ? overlayClasses.sceOverlayContent : overlayClasses.sceOverlayContentConfirmPopup}>
              <div ref={this.setWrapperRef} className={this.state.isViewEditPopup ? overlayClasses.sceDialogBox : overlayClasses.sceDialogBoxConfirmPopup}>
                {this.state.isViewEditPopup ?
                  <React.Fragment>
                    <div className='row'>
                      <div className={'col-xs-12 ' + classes.sceSetNotificationMainHeader}>{this.strings.ViewEditPopupTitle}<button className={classes.iconClose} onClick={this.props.isOpen} ><img src={this.closeIcon} alt="Close Icon" /></button></div>
                    </div>
                    {this.state.twoFactorAuthValues.isPopUpOpen ? <TwoFactorAuthContainer factors closePopup={this.twofactorAuthPopupClose} twoFactorAuthValues={this.state.twoFactorAuthValues} onTwoFACompleted={this.onTwoFACompleted} />
                      :
                      <div>
                        <div className='row'>
                          <div className={'col-xs-12 ' + classes.sceSetNotificationHeader}>{this.strings.Account}</div>
                        </div>
                        <div className={classes.scrollContentViewEditpopup}>
                          {serviceAccountDetailsJSX}
                          <div className={classes.emailNotification}>
                            <div className={classes.notificationLabel}><img className={classes.labelImages} src={this.emailIcon} alt="Email Icon" />{this.strings.Email}</div>
                            <div className={classes.dividerLine} />
                            <div>
                              <div className={this.state.showButtonPress ? classes.showFullContent : ''}>
                              {showEmails.map((emailObj, index) =>
                                <div key={index}  >
                                  {this.state.editIndex === index ? this.renderAddEmailJsx():
                                    <span>
                                      {this.state.removeIndex !== index && (<button className={classes.removeIcon} onClick={()=>this.removeIconHandler(index)}><img src={this.removeIcon} alt="Remove Icon" /></button> )}
                                      <span className={classes.emailData}>
                                        <span> {emailObj.email.replace(/^(...)(.*)(@.*)$/, (_, a, b, c) => a + '****' + c)}</span>
                                      </span>
                                      {this.state.removeIndex === index && (
                                        <span className={classes.buttonAlign}>
                                          <span className={classes.removeButtonAlign}><button className={classes.RemoveButton} onClick={()=>this.removeButtonHandler(emailObj.email, index)}>{this.strings.RemoveButtonValue}</button></span>
                                          <span className={classes.EditButtonAlign}><button className={classes.CancelButton} onClick={this.semiCancelButtonHandler}>{this.strings.CancelButtonValue}</button></span>
                                        </span>)}
                                      {this.state.editIndex !== index &&  this.state.removeIndex !== index && emailObj.type ==='soldTo' &&  (
                                        <span className={classes.editButtonAlign}>
                                          <button className={classes.EditButton} onClick={()=>this.editButtonHandler(emailObj.email, index)}>{this.strings.EditButtonValue}</button>
                                        </span>)}
                                      <div className={classes.dividerLine} />
                                    </span>}
                                </div>
                              )}
                              </div>
                             {this.state.showMoreOption ? !this.state.showButtonPress? <div className={classes.ShowMore}><SceButton id="viewAll"   iconType='downArrow' onClick={this.viewAllHandler} value={this.strings.ShowMore} /></div> :<div className={classes.ShowMore}><SceButton id="viewAll"  iconType='upArrow' onClick={this.viewAllHandler} value={this.strings.ShowLess} /></div>:null}
                              {canShowAddEmail? this.state.showDropDown ?
                                <div className={classes.sceAddButtonContainer + ' row'} >
                                  <button
                                    className={!canShowAddEmail ? classes.sceCPPAddButtonDisabled : classes.sceCPPAddButton} disabled={!canShowAddEmail}
                                    onClick={this.onAddEmailClickHandler}>
                                    {(!canShowAddEmail) ? null : <div><img className={classes.addIcon} src={this.addIcon} alt="Add Icon" />
                                      <span className={classes.addBtnTxt}>{this.strings.PbAlertAddEmail}</span></div>}
                                  </button>
                                </div> :this.renderAddEmailJsx(): null}
                            </div>
                          </div>
                        </div>
                        {this.state.doneEnable ?
                          <div className={["text-align-center", classes.buttonSection].join(' ')}>
                            <div className={classes.footerButton}><SceButton id="paperlessBillingDone" buttonType="primary" value={this.strings.DoneButtonValue} onClick={this.doneButtonHandler} /></div>
                          </div>
                          :
                          <div className={"text-align-center"}><div className={classes.footerButton}><SceButton id="paperlessBillingDone" buttonType="sceDisabled" value={this.strings.DoneButtonValue} /></div>
                          </div>}
                      </div>
                    }
                  </React.Fragment>:
                  <div>
                    <div className='row'>
                      <div className={'col-xs-12 ' + classes.sceMsgIcon}>{this.state.msgIcon ? <img src={this.verifiedIcon} alt="Verified Icon" width="35px" height="35px" /> : <img src={this.removeIcon} alt="close Icon" width="35px" height="35px" />}</div>
                      <div className={'col-xs-12 ' + classes.sceVcConfirm}>{this.state.popUpMsg}</div>
                    </div>
                    <div className={["text-align-center", classes.buttonSection].join(' ')}>
                      <div className={classes.Okbtn}>
                        <SceButton id="paperlessBillingCancel" buttonType="primary" value={this.strings.CloseButtonValue} onClick={this.props.closePopUp} />
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>;
        </div>
      </FocusTrap>
      }
      </React.Fragment>      
    );
  }
}
export default ViewEditPaperlessBilling;
